type AnyObject = Record<string, any>;

function isObject(item: any): item is AnyObject {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export function deepMergeObjects(target: AnyObject, ...sources: AnyObject[]): AnyObject {
  if (!sources.length) {
    return target;
  }

  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} });
        }
        deepMergeObjects(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return deepMergeObjects(target, ...sources);
}
